import React, { useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";

import { useDispatch } from "react-redux";

import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import HomeIcon from "@mui/icons-material/Home";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import RequestPageRoundedIcon from "@mui/icons-material/RequestPageRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";
import AddIcCallOutlinedIcon from "@mui/icons-material/AddIcCallOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { logoutUser } from "../../redux/user/UserAction";

const Item = ({ title, to, icon, selected, setSelected, onClick }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleItemClick = () => {
    onClick(); // Call the onClick function
    setSelected(title); // Update the selected item
  };

  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={handleItemClick}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");

  const logout = () => {
    console.log("clicked logout");
    dispatch(logoutUser());
  };

  const handleItemClick = () => {
    // Define the handleclick logic here
    console.log("Item clicked");
  };

  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            {/* Pass the clickAccount function as onClick prop */}
            <Item
              title="Dashboard"
              to="/user"
              icon={<HomeIcon />}
              selected={selected}
              setSelected={setSelected}
              onClick={handleItemClick}
            />
            <Item
              title="Transactions"
              to="/transactions"
              icon={<ReceiptRoundedIcon />}
              selected={selected}
              setSelected={setSelected}
              onClick={handleItemClick}
            />

            <Item
              title="Requests"
              to="/transactions-request"
              icon={<RequestPageRoundedIcon />}
              selected={selected}
              setSelected={setSelected}
              onClick={handleItemClick}
            />

            {/* Pass the clickAccount function as onClick prop */}
            <Item
              title="Profile"
              to="/profile"
              icon={<PersonOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
              onClick={handleItemClick}
            />

            {/* Pass the clickAccount function as onClick prop */}
            <Item
              title="Account"
              to="/account"
              icon={<AccountBalanceOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
              onClick={handleItemClick}
            />

            {/* Pass the clickAccount function as onClick prop */}
            <Item
              title="Help"
              to="/help"
              icon={<HelpOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
              onClick={handleItemClick}
            />

            {/* Pass the clickAccount function as onClick prop */}
            <Item
              title="Contact Us"
              to="/contact"
              icon={<AddIcCallOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
              onClick={handleItemClick}
            />

            {/* Pass the logout function as onClick prop */}
            <Item
              title="Logout"
              // to="/buyer-login"
              icon={<LogoutOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
              onClick={logout}
            />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
